/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 03.07.25
 *
 */
export const ModalityType = Object.freeze({
	TLSW: "TLSW",
	PLAY_THERAPY: "PLAY_THERAPY",
})

export const ModalityName = Object.freeze({
	[ModalityType.TLSW]: "Therapeutic Life Story Work (TLSW)",
	[ModalityType.PLAY_THERAPY]: "Play Therapy",
})
